import { Base } from "ui/Scripts/source/framework/base";
import { IListItems, ListItems } from "ui/Scripts/source/framework/listItems";
import { DocumentTemplateListItem, IDocumentTemplateListItem } from "./documentTemplateListItem";

export interface IDocumentTemplateListItems extends IListItems<IDocumentTemplateListItem> {}

export class DocumentTemplateListItems extends ListItems<DocumentTemplateListItem> implements IDocumentTemplateListItems {
    constructor();
    constructor(obj: IDocumentTemplateListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, DocumentTemplateListItem);
    }
}